import Vue from "vue"
import {Storage} from '../Utils'


let analyticsInitialized = false

function loadUserId() {
    if (analyticsInitialized) {
        Vue.$ga.set('userId', Storage.getUser().id)
    }
}

function clearUserId() {
    if (analyticsInitialized) {
        Vue.$ga.set('userId', null)
    }
}


export default {
    loadUserId,
    clearUserId,
}
